import ConfiguracaoPisCofins from './ConfiguracaoPisCofins'

class CadastrarFiliaisModal {
  constructor(gql, $scope, modal) {
    this.apply = fun => $scope.$applyAsync(fun)
    this.gql = gql
    this.modal = modal

    this.filiais = []

    $scope.$watch(
      () => this.filial && !this.filial.id ? this.filial.finalCnpj : null,
      (finalCnpj, before) => {
        if (finalCnpj && finalCnpj !== before) {
          this.filial.cnpj = `${this.contrato.raizCnpj}${finalCnpj.replace(/\D/g, '')}`
        }
      }
    )

    $scope.$watch(
      () => this.filial && !this.filial.id ? this.filial.cnpj : null,
      (cnpj, before) => {
        if (cnpj && cnpj !== before && cbk.validateCnpj(cnpj)) {
          const dadosCadastraisPromise = this
            .loadDadosCadastrais(cnpj)
            .then(({ empresa }) =>
              this.filial = {
                ...this.filial,
                ...empresa
              }
            )
            .catch(console.error)
            .finally(() => this.apply())

          this.promise = this.promise ? Promise.all([this.promise, dadosCadastraisPromise]) : dadosCadastraisPromise
        }
      }
    )
  }

  $onInit() {
    this.initialPromise = this
      .loadFiliais()
      .then(({ empresas, contrato }) => {
        this.filiais = empresas
        this.contrato = contrato
      })
      .finally(() => this.apply())
  }

  loadFiliais() {
    const query = gql`
            fragment FilialParts on Filial {
                id
                razaoSocial
                cnpj
                status: ativa
                icms {
                    id
                    atividades {
                        id
                        descricao
                        desativado
                    }
                    regimeTributario {
                        id
                        nome
                    }
                    perfis {
                        perfil {
                            id
                            nome
                        }
                        configuracoes {
                            cnpjFornecedores
                            numeroTermo
                        }
                    }
                    vigencia {
                        from
                        to
                    }
                }
                icmsVigente {
                    id
                }
                pisCofins {
                    id
                    aliquotaPis
                    aliquotaCofins
                    regimeTributario {
                        id
                        nome
                    }
                    atividade
                    vigencia {
                        from
                        to
                    }
                }
                pisCofinsVigente {
                    id
                }
                cidade {
                    id
                    nome
                    estado {
                        id
                        sigla
                    }
                }
            }
            query Empresa {
                contrato: empresa(id: ${this.resolve.contratoId}) {
                    id
                    raizCnpj
                    razaoSocial
                    inativas: filiais(ativa: false) {
                        ...FilialParts
                    }
                    ativas: filiais(ativa: true) {
                        ...FilialParts
                    }
                }
            }
        `

    return this.gql
      .query(query)
      .then(({ contrato }) => {
        const { inativas, ativas, ...rest } = contrato
        const empresas = [...inativas, ...ativas]
          .sortBy(e => e.cnpj)
          .sortBy(e => !e.status)

        return {
          contrato: rest,
          empresas: empresas.map(empresa => {
            const icms = empresa.icms.map(icms => ({
              ...icms,
              atividades: icms.atividades.reject(({ desativado }) => desativado)
            }))

            const icmsVigente = empresa.icmsVigente && icms.find(i => i.id === empresa.icmsVigente.id)
            const pisCofinsVigente = empresa.pisCofinsVigente && empresa.pisCofins.find(p => p.id === empresa.pisCofinsVigente.id)

            return {
              ...empresa,
              icms,
              icmsVigente,
              pisCofinsVigente,
              finalCnpj: empresa.cnpj.slice(8)
            }
          })
        }
      })
  }

  loadDadosCadastrais(cnpj) {
    const query = gql`
            query DadosCadastrais($cnpj: String!) {
                empresa: dadosCadastrais(cnpj: $cnpj) {
                    razaoSocial
                    cnpj
                    cidade {
                        id
                        nome
                        estado {
                            id
                            sigla
                        }
                    }
                }
            }
        `

    return this.gql.query(query, { cnpj })
  }

  loadCidades(search) {
    const query = gql`
            query Cidades($nomeSearch: String!, $limit: Int!){
                cidades(nomeSearch: $nomeSearch, limit: $limit) {
                    id
                    nome
                    estado {
                        id
                        sigla
                    }
                }
            }
        `

    return this.cidadesPromise = this
      .gql
      .query(query, { nomeSearch: search, limit: 10 })
      .then(({ cidades }) => this.cidades = cidades)
      .finally(() => this.apply())
  }

  createFilial(filial) {
    const mutation = gql`
            mutation CreateFilial($empresaId: String!, $params: FilialParams!) {
                empresa(id: $empresaId) {
                    empresa: createFilial(params: $params) {
                        id
                        status: ativa
                    }
                }
            }
        `

    const variables = {
      empresaId: this.contrato.id,
      params: {
        razaoSocial: filial.razaoSocial,
        cnpj: filial.cnpj,
        cidadeId: filial.cidade.id
      }
    }

    return this.gql.mutate(mutation, variables)
  }

  updateFilial(filial) {
    const mutation = gql`
            mutation UpdateFilial($empresaId: String!, $filialId: String!, $params: FilialParams!) {
                empresa(id: $empresaId) {
                    empresa: updateFilial(filialId: $filialId, params: $params) {
                        id
                        status: ativa
                        razaoSocial
                        cidade {
                            id
                            nome
                            estado {
                                id
                                sigla
                            }
                        }
                    }
                }
            }
        `

    const variables = {
      empresaId: this.contrato.id,
      filialId: filial.id,
      params: {
        razaoSocial: filial.razaoSocial,
        cidadeId: filial.cidade.id,
        ativa: filial.status
      }
    }

    return this.gql.mutate(mutation, variables)
  }

  desativarAtivarFilial() {
    this.promise = this
      .updateFilial({ ...this.filial, status: !this.filial.status })
      .then(({ empresa }) => this.afterUpdateFilial(empresa.empresa))
      .finally(() => this.apply())
  }

  submit() {
    this.form.finalCnpj.$setValidity('cnpj', this.filial.cnpj && cbk.validateCnpj(this.filial.cnpj))

    if (this.form.$valid) {
      const promise = this.filial.id ? this.updateFilial(this.filial) : this.createFilial(this.filial)

      return this.promise = promise
        .then(({ empresa }) => this.afterUpdateFilial(empresa.empresa))
        .catch(errors => {
          const existsCnpj = errors.some(({ key }) => key === 'cnpj')

          this.form.finalCnpj
            .$setValidity('exists', !existsCnpj)
        })
        .finally(() => this.apply())
    }
  }

  afterUpdateFilial(filial) {
    this.filial = { ...this.filial, ...filial }

    this.filiais = [this.filial, ...this.filiais]
      .uniqBy(e => e.cnpj)
      .sortBy(e => e.cnpj)
      .sortBy(e => !e.status)

    this.form.$setPristine()
  }

  editarIcms() {
    this.modal
      .open({
        component: 'configuracaoIcmsModal',
        size: 'lg',
        keyboard: 'static',
        resolve: {
          filialId: () => this.filial.id,
          empresaId: () => this.resolve.contratoId
        }
      })
      .result.then(icmsVigente => {
        if (icmsVigente) {
          this.afterUpdateFilial({ ...this.filial, icmsVigente: icmsVigente.icms })
        }
        this.apply()
      })
  }

  editarPisCofins() {
    this.modal
      .open({
        component: 'configuracaoPisCofinsModal',
        size: 'lg',
        keyboard: 'static',
        resolve: {
          filialId: () => this.filial.id,
          empresaId: () => this.resolve.contratoId
        }
      })
      .result.then(pisCofinsVigente => {
        if (pisCofinsVigente) {
          this.afterUpdateFilial({ ...this.filial, pisCofinsVigente: pisCofinsVigente.pisCofins })
        }
      })
  }

  selectFilial(filial) {
    this.filial = { ...filial }
  }

  getPisCofinsAtividade(atividadeId) {
    return ConfiguracaoPisCofins.atividades.find(at => at.id === atividadeId)
  }
}

angular.module('eficienciaFiscalModule').component('cadastrarFiliaisModal', {
  controller: ['gql', '$scope', '$uibModal', CadastrarFiliaisModal],
  bindings: {
    close: '&',
    resolve: '<'
  },
  template: `
    <modal modal-title="Cadastro de filiais" close="$ctrl.close">
      <modal-body>
        <loading promise="$ctrl.initialPromise">
          <div class="principal">
            <div class="filiais-container">
              <div class="form-busca">
                <button class="btn btn-info" ng-click="$ctrl.selectFilial({})">Adicionar</button>
                <div class="input-icon">
                  <input ng-model="$ctrl.search" placeholder="Digite aqui para filtrar" class="form-control" />
                  <i class="fa fa-search icon"></i>
                </div>
              </div>
              <div class="filiais">
                <div ng-repeat="filial in $ctrl.filiais | filter: $ctrl.search" class="filial"
                  ng-class="{'disabled': !filial.status}" ng-click="$ctrl.selectFilial(filial)"
                  title="{{filial.razaoSocial}}">
                  <div class="razao-cnpj">
                    <div>
                      {{filial.razaoSocial}}
                    </div>
                    <div style="margin-left: 5px;">
                      <small class="text-muted">{{filial.cnpj | cpfCnpj}}</small>
                    </div>
                  </div>
                  <span class="text-muted">{{filial.cidade.nome}} - {{filial.cidade.estado.sigla}}</span>
                </div>
              </div>
            </div>
            <div class="no-filial-select" ng-if="!$ctrl.filial">
              <highlighted>
                <main>Nenhuma filial selecionada.</main>
                <secondary>
                  Selecione uma filial na lista a esquerda ou
                  <a href="javascript:void(0)" ng-click="$ctrl.selectFilial({})">clique aqui</a>
                  para adicionar uma nova.
                </secondary>
              </highlighted>
            </div>
            <div class="cadastro-container" ng-if="$ctrl.filial">
              <div class="dados-filial">
                <loading promise="$ctrl.promise" class="loading-blurred" active="isFilialLoading">
                  <button class="btn btn-link btn-xs pull-right" ng-click="$ctrl.desativarAtivarFilial()"
                    ng-if="$ctrl.filial.id">
                    {{$ctrl.filial.status ? 'Desativar' : 'Ativar'}}
                  </button>
                  <h5>Dados da filial <span class="label label-danger"
                      ng-show="$ctrl.filial.id && !$ctrl.filial.status">Desativada</span></h5>

                  <form name="$ctrl.form" ng-submit="$ctrl.submit()" novalidate>
                    <div class="row">
                      <div class="form-group col-xs-12 col-md-4">
                        <label>CNPJ</label>
                        <div class="input-group">
                          <span class="input-group-addon">
                            {{$ctrl.contrato.raizCnpj | cpfCnpj}}
                          </span>
                          <input class="form-control" name="finalCnpj" ng-model="$ctrl.filial.finalCnpj" ui-mask="9999-99"
                            ui-mask-return="false" ng-disabled="isFilialLoading || $ctrl.filial.id"
                            ng-change="$ctrl.form.finalCnpj.$setValidity('exists', true)" required />
                        </div>
                        <div ng-messages="$ctrl.form.finalCnpj.$error" ng-if="$ctrl.form.$submitted">
                          <span class='help-block txt-color-red font-xs no-margin' ng-message="required">Nenhum CNPJ foi
                            informado.
                          </span>
                          <span class='help-block txt-color-red font-xs no-margin' ng-message="cnpj">O
                            CNPJ informado não é válido.
                          </span>
                          <span class='help-block txt-color-red font-xs no-margin' ng-message="exists">O CNPJ informado já
                            foi cadastrado.
                          </span>
                        </div>
                      </div>
                      <div class="form-group col-xs-12 col-md-8">
                        <label>Razão social</label>
                        <input class="form-control" name="razaoSocial" ng-model="$ctrl.filial.razaoSocial"
                          ng-disabled="isFilialLoading" required />
                        <div ng-messages="$ctrl.form.razaoSocial.$error" ng-if="$ctrl.form.$submitted">
                          <span class='help-block txt-color-red font-xs no-margin' ng-message="required">Este campo é
                            obrigatório.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <promise-tracker promise="$ctrl.cidadesPromise" active="isCidadeLoading">
                        <div class="form-group col-xs-12 col-sm-8 col-md-9">
                          <label>Cidade</label>

                          <span class="spinner" ng-if="isCidadeLoading">
                            <i class="fa fa-spin fa-circle-o-notch"></i>
                          </span>

                          <ui-select theme="bootstrap" name="cidade" ng-model="$ctrl.filial.cidade"
                            ng-class="{'spinner-select': isCidadeLoading}" reset-search-input="false" required>
                            <ui-select-match>
                              {{$select.selected.nome}} - {{$select.selected.estado.sigla}}
                            </ui-select-match>
                            <ui-select-choices repeat="cidade in $ctrl.cidades" refresh="$ctrl.loadCidades($select.search)"
                              refresh-delay="500">
                              <div>{{cidade.nome}} - {{cidade.estado.sigla}}</div>
                            </ui-select-choices>
                          </ui-select>
                          <div ng-messages="$ctrl.form.cidade.$error" ng-if="$ctrl.form.$submitted">
                            <span class='help-block txt-color-red font-xs no-margin' ng-message="required">Nenhuma cidade
                              foi selecionada.
                            </span>
                          </div>
                        </div>
                      </promise-tracker>
                      <div class="form-group col-xs-12 col-sm-4 col-md-3">
                        <label class="hidden-xs">&nbsp;</label>
                        <button class="btn btn-primary btn-block" ng-disabled="isFilialLoading">
                          {{$ctrl.filial.id ? 'Salvar' : 'Adicionar'}}
                        </button>
                      </div>
                    </div>
                  </form>
              </div>
        </loading>
        <div class="parametros-icms" ng-if="$ctrl.filial.id">
          <h5>
            Parâmetros de ICMS vigentes
            <a href="javascript:void(0)" ng-click="$ctrl.editarIcms()">
              <span ng-show="$ctrl.filial.icmsVigente">Editar</span>
              <span ng-hide="$ctrl.filial.icmsVigente">Configurar</span>
            </a>
          </h5>
          <span ng-hide="$ctrl.filial.icmsVigente" class="text-muted">Não existe nenhuma configuração vigente.</span>
          <div ng-if="$ctrl.filial.icmsVigente">
            <b>Vigencia: </b>
            {{$ctrl.filial.icmsVigente.vigencia.from ? ($ctrl.filial.icmsVigente.vigencia.from | date: 'dd/MM/yyyy') : '...'}}
            até
            {{$ctrl.filial.icmsVigente.vigencia.to ? ($ctrl.filial.icmsVigente.vigencia.to | date: 'dd/MM/yyyy') : '...'}}
            <br>
            <b>Regime tributário:</b> {{$ctrl.filial.icmsVigente.regimeTributario.nome}}
            <br>
            <b>Atividades</b>
            (<a href="javascript:void(0)" ng-click="$ctrl.showAtividades = !$ctrl.showAtividades">
              {{$ctrl.showAtividades ? 'ocultar' : 'exibir'}}
            </a>)
            <ul ng-show="$ctrl.showAtividades" class="slide-animation">
              <li ng-repeat="atividade in $ctrl.filial.icmsVigente.atividades">
                {{atividade.descricao}}
              </li>
            </ul>
            <br>
            <b ng-if="$ctrl.filial.icmsVigente.perfis.length">Perfis</b>
            <ul ng-if="$ctrl.filial.icmsVigente.perfis.length">
              <li ng-repeat="perfil in $ctrl.filial.icmsVigente.perfis">
                <span>{{perfil.perfil.nome}}</span>
                <span ng-show="perfil.configuracoes.numeroTermo">
                  (Nº termo: {{perfil.configuracoes.numeroTermo}})
                </span>
                <div ng-if="perfil.configuracoes.cnpjFornecedores.length">
                  <small class="text-muted">
                    Possui CNPJ de fornecedores
                    (<a href="javascript:void(0)" ng-click="perfil.showCnpjFornecedores = !perfil.showCnpjFornecedores">
                      {{perfil.showCnpjFornecedores ? 'ocultar' : 'exibir'}}
                    </a>)
                  </small>
                  <ul ng-show="perfil.showCnpjFornecedores" class="slide-animation">
                    <li ng-repeat="cnpjFornecedor in perfil.configuracoes.cnpjFornecedores">
                      {{cnpjFornecedor | cpfCnpj}}
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="parametros-pis-cofins" ng-if="$ctrl.filial.id">
          <h5>
            Parâmetros de PIS/COFINS vigentes
            <a href="javascript:void(0)" ng-click="$ctrl.editarPisCofins()">
              <span ng-show="$ctrl.filial.pisCofinsVigente">Editar</span>
              <span ng-hide="$ctrl.filial.pisCofinsVigente">Configurar</span>
            </a>
          </h5>
          <span ng-hide="$ctrl.filial.pisCofinsVigente" class="text-muted">Não existe nenhuma configuração
            vigente.</span>
          <div ng-if="$ctrl.filial.pisCofinsVigente">
            <b>Vigencia: </b>
            {{$ctrl.filial.pisCofinsVigente.vigencia.from ? ($ctrl.filial.pisCofinsVigente.vigencia.from | date: 'dd/MM/yyyy') : '...'}}
            até
            {{$ctrl.filial.pisCofinsVigente.vigencia.to ? ($ctrl.filial.pisCofinsVigente.vigencia.to | date: 'dd/MM/yyyy') : '...'}}
            <br>
            <b>Regime tributário:</b> <span>{{$ctrl.filial.pisCofinsVigente.regimeTributario.nome}}</span>
            <br>
            <b>Alíquota PIS:</b> <span>{{$ctrl.filial.pisCofinsVigente.aliquotaPis | number: 2}}</span>
            <br>
            <b>Alíquota COFINS:</b> <span>{{$ctrl.filial.pisCofinsVigente.aliquotaCofins | number: 2}}</span>
            <br>
            <b>Atividade:</b>
            <span>{{$ctrl.getPisCofinsAtividade($ctrl.filial.pisCofinsVigente.atividade).nome}}</span>
          </div>
        </div>
        </div>
        </div>
        </loading>
      </modal-body>
      <modal-footer>
        <button class="btn btn-default" type="button" ng-click="$ctrl.close()">Fechar</button>
      </modal-footer>
    </modal>
  `
})
